require
<template>
  <div class="home-wrapper">
    <form>
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 offset-lg-2  offset-md-3">
            <div class="forlogin">
              <h5>Please login if you are already an account holder of Ghost Inc.
              </h5>
              <a class="btn btn-primary btn-lg" href='/login'>Login</a>
            </div>
          </div>
          <!-- <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="forsubscribe">
              <h5>Please subscribe and signup for $199.</h5>
              <a class="btn btn-warning btn-lg" href='/subscribe'>Subscribe</a>
            </div>
          </div> -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="forsubscribe">
              <h5>Free Signup</h5>
              <a class="btn btn-warning btn-lg" href='/freesignup'>Free Signup</a>
            </div>
          </div>
        </div>
      </div> 
    </form>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue